import classnames from 'classnames';
import React from 'react';

const CSS = require('./Input.module.scss');

interface InputProps {
  className?: string;
  onChange: (event) => void;
  error?: any;
  labelName: string;
  inputRef?: any;
  type: string;
  name: string;
  placeholder: string;
  autoComplete?: string;
  alwaysShowLabel?: boolean;
  [key: string]: any;
}

function Input(
  {
    className,
    onChange,
    error,
    labelName,
    autoComplete,
    alwaysShowLabel,
    ...rest
  }: InputProps,
  inputRef,
) {
  return (
    <div className={classnames(CSS.InputGroup, { [className]: className })}>
      <label
        htmlFor={labelName}
        className={classnames(CSS.InputLabel, {
          [CSS.InputLabelConditionalHide]: !alwaysShowLabel,
        })}
      >
        {labelName}
      </label>
      <input
        autoComplete={autoComplete}
        ref={inputRef}
        onChange={onChange}
        id={labelName}
        className={classnames(CSS.Input, { [CSS.InputError]: !!error })}
        {...rest}
      />
      {error && <span className={CSS.Error}>{error}</span>}
    </div>
  );
}

export default React.forwardRef(Input);
